import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { BsgShoeWidth } from '../../api/models';

export type TABLE_TYPE = Table<BsgShoeWidth>;

export const TABLE = 'bsgShoeWidth';
const SCHEMA = 'bsgShoeWidthId, sortId';

class BsgShoeWidthDatabase implements DataRepository<BsgShoeWidth> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<BsgShoeWidth | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: BsgShoeWidth, key: Key): Promise<BsgShoeWidth> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: BsgShoeWidth[]): Promise<BsgShoeWidth[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<BsgShoeWidth[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const BsgShoeWidthDB = new BsgShoeWidthDatabase(db);
